import { Flex } from 'antd';
import classNames from 'classnames';

import { ReactComponent as LuggageIcon } from '@Icons/profile/luggage.svg';
import { ReactComponent as LeafIcon } from '@Icons/profile/leaf.svg';
import { ReactComponent as WarningIcon } from '@Icons/profile/warning.svg';
import { ReactComponent as ChartIcon } from '@Icons/profile/chart.svg';
import { Balance } from '@Types/api/form/leaveRequest/Balance';

import styles from './summary.module.css';
import { SummaryCard } from './components/SummaryCard';

interface SummaryProps {
  balance: Balance | null;
  isMobile: boolean;
}

const Summary: React.FC<SummaryProps> = ({ balance, isMobile }) => {
  return (
    <Flex className={classNames(styles.wrapper, isMobile ? 'mobile' : null)}>
      <SummaryCard
        isMobile={isMobile}
        title="Annual Leave"
        counter={balance?.annualLeaveThisYear}
        icon={<LuggageIcon />}
      />
      <SummaryCard
        isMobile={isMobile}
        title="Sick Leave"
        counter={balance?.sickLeaveThisYear}
        icon={<LeafIcon />}
      />
      <SummaryCard
        isMobile={isMobile}
        title="Emergency Leave"
        counter={balance?.emergencyLeaveThisYear}
        icon={<WarningIcon />}
      />
      <SummaryCard
        isMobile={isMobile}
        title="Remaining Balance"
        counter={balance?.asOnToday}
        icon={<ChartIcon />}
      />
    </Flex>
  );
};

export default Summary;
